// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"fc36b2d8","455":"492e6b75","946":"a6b67ecf"}[chunkId] + ".chunk.js";
};